import { render, staticRenderFns } from "./ParagraphBlock.vue?vue&type=template&id=45284f60&scoped=true"
import script from "./ParagraphBlock.vue?vue&type=script&lang=js"
export * from "./ParagraphBlock.vue?vue&type=script&lang=js"
import style0 from "./ParagraphBlock.vue?vue&type=style&index=0&id=45284f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45284f60",
  null
  
)

export default component.exports